import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";

export class RelatedNews {
  constructor ({data, api, config,...other}) {

    this.mediaId = config.mediaId;
    this.api = api;
    this.isOnlyLoading = !!data?.url;
    this.data = {
      url: data?.url || '',
      isValid: data?.isValid || false,
      slug: data?.slug,
      image: data?.image,
      title: data?.title,
      media: {
        base_path: data?.media?.base_path
      }
    };

    this.wrapper = null;
    this.urlInput = null;
    this.validationButton = null;
    this.render();
  }

  render () {
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('related-news');

    // Estilos al contenedor
    this.wrapper.style.border = '1px solid rgba(201,201,204,.48)';
    this.wrapper.style.padding = '13px';
    this.wrapper.style.borderRadius = ' 3px';
    this.wrapper.style.background = '#fff';
    this.wrapper.style.fontSize = '14.9px';
    this.wrapper.style.width = '90%';


    // Si no hay contenido previamente guardado, mostrar el formulario
    if (!this.data.isValid) {
      this.urlInput = document.createElement('input');
      this.urlInput.setAttribute('type', 'text');
      this.urlInput.setAttribute('placeholder', 'Ingrese la URL de la noticia relacionada');
      this.urlInput.value = this.data.url;

      this.validationButton = document.createElement('button');
      this.validationButton.innerText = 'Validar Noticia';
      this.validationButton.addEventListener('click', async (event) => {
        event.preventDefault(); // Evita la recarga de la página

        const url = this.urlInput.value.trim();
        let path = ""
        try {
          const urlObject = new URL(url);
          if (urlObject.hostname && urlObject.pathname) {
            path = urlObject.pathname
          } else {
            await Swal.fire({
              icon: "error",
              title: "Error al validar la noticia relacionada",
              text: "Revisa la url ingresada",
            });
            this.api.blocks.delete();
            return
          }
        } catch (error) {
          await Swal.fire({
            icon: "error",
            title: "Error al validar la noticia relacionada",
            text: "Revisa la url ingresada",
          });
          this.api.blocks.delete();
          return
        }

        try {
          const response = await axios.post(`${config.apiUrl}/api/v1/posts/search/slug`, {
            slug: path,
            media_id: this.mediaId,
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          });

          if (response.status === 200) {
            this.urlInput.style.display = 'none';
            this.validationButton.style.display = 'none';

            const relatedArticleDivResp = document.createElement('div');
            relatedArticleDivResp.className = 'related-article';
            relatedArticleDivResp.style.display = 'flex';
            relatedArticleDivResp.style.justifyContent = 'space-between';
            relatedArticleDivResp.style.alignItems = 'center';

            const titleParagraphResp = document.createElement('p');
            titleParagraphResp.className = 't-action';
            titleParagraphResp.style.margin = '0';
            titleParagraphResp.innerText = url;

            const removeButtonResp = document.createElement('button');
            removeButtonResp.innerText = 'Eliminar';
            removeButtonResp.style.border = '1px solid #ccc';
            removeButtonResp.style.borderRadius = '4px';
            removeButtonResp.style.padding = '5px 10px';
            removeButtonResp.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
            removeButtonResp.addEventListener('click', () => {
              this.api.blocks.delete();
            });

            relatedArticleDivResp.appendChild(titleParagraphResp);
            relatedArticleDivResp.appendChild(removeButtonResp);

            this.wrapper.appendChild(relatedArticleDivResp);

            this.data.slug = response.data.post.slug;
            this.data.image = response.data.post.content_image;
            this.data.media.base_path = response.data.post.media.base_path
            this.data.title = response.data.post.title;
            this.data.isValid = true;

          } else {
            await Swal.fire({
              icon: "warning",
              title: "Error al validar la noticia relacionada",
              text: "Vuelva a intentarlo ",
            });
            this.urlInput.value = '';
            this.api.blocks.delete();
          }
        } catch (error) {
          await Swal.fire({
            icon: "warning",
            title: "Error al validar la noticia relacionada",
            text: "Vuelva a intentarlo ",
          });

          this.api.blocks.delete();
        }
      });

      // Estilos al input
      this.urlInput.style.width = '100%';
      this.urlInput.style.border = '1px solid grey';
      this.urlInput.style.padding = '5px';
      this.urlInput.style.boxSizing = 'border-box';
      this.urlInput.style.border = '1px solid #ccc';
      this.urlInput.style.borderRadius = '4px';
      this.urlInput.style.padding = '5px 10px';
      this.urlInput.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
      this.urlInput.style.marginTop = '5px';

      // Estilos para el botón
      this.validationButton.style.border = '1px solid #ccc';
      this.validationButton.style.borderRadius = '4px';
      this.validationButton.style.padding = '5px 10px';
      this.validationButton.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
      this.validationButton.style.marginTop = '5px';
      this.validationButton.style.backgroundColor = '#ffffff'; // Color de fondo blanco
      this.validationButton.style.color = '#000000'; // Color de texto negro
      this.validationButton.style.cursor = 'pointer'; // Cambia el cursor al pasar sobre el botón

      this.wrapper.appendChild(this.urlInput);
      this.wrapper.appendChild(this.validationButton);
    } else {
      // Si hay contenido previamente guardado, mostrar el contenido existente
      const relatedArticleDiv = document.createElement('div');
      relatedArticleDiv.className = 'related-article';
      relatedArticleDiv.style.display = 'flex';
      relatedArticleDiv.style.justifyContent = 'space-between';
      relatedArticleDiv.style.alignItems = 'center';

      const titleParagraph = document.createElement('p');
      titleParagraph.className = 't-action';
      titleParagraph.style.margin = '0';
      titleParagraph.innerText = this.data.url;

      const removeButton = document.createElement('button');
      removeButton.innerText = 'Eliminar';
      removeButton.style.border = '1px solid #ccc';
      removeButton.style.borderRadius = '4px';
      removeButton.style.padding = '5px 10px';
      removeButton.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
      removeButton.addEventListener('click', () => {
        this.api.blocks.delete();
      });

      relatedArticleDiv.appendChild(titleParagraph);
      relatedArticleDiv.appendChild(removeButton);

      this.wrapper.appendChild(relatedArticleDiv);
    }

    return this.wrapper;
  }

  save () {
    if (this.isOnlyLoading) {
      return this.data;
    }
    return {
      url: this.urlInput?.value?.trim(),
      isValid: this.data.isValid,
      slug: this.data.slug,
      image: this.data.image,
      title: this.data.title,
      media: {
        base_path: this.data.media.base_path
      }
    };
  }

  static get toolbox () {
    return {
      title: 'Related News',
      icon: '<svg width="17" height="17" xmlns="http://www.w3.org/2000/svg"><path d="M7.161 3.346c0-.55.448-.998.998-.998h1.682c.55 0 .998.448.998.998v1.682a.998.998 0 01-.998.998H8.159a.998.998 0 01-.998-.998V3.346zm0 4.345c0-.55.448-.998.998-.998h1.682c.55 0 .998.448.998.998v1.682a.998.998 0 01-.998.998H8.159a.998.998 0 01-.998-.998V7.69zm0 4.34c0-.55.448-.998.998-.998h1.682c.55 0 .998.448.998.998v1.682a.998.998 0 01-.998.998H8.159a.998.998 0 01-.998-.998v-1.682zM4.495 3.346c0-.55.448-.998.998-.998h1.682c.55 0 .998.448.998.998v1.682a.998.998 0 01-.998.998H5.493a.998.998 0 01-.998-.998V3.346zm0 4.345c0-.55.448-.998.998-.998h1.682c.55 0 .998.448.998.998v1.682a.998.998 0 01-.998.998H5.493a.998.998 0 01-.998-.998V7.69zm0 4.34c0-.55.448-.998.998-.998h1.682c.55 0 .998.448.998.998v1.682a.998.998 0 01-.998.998H5.493a.998.998 0 01-.998-.998v-1.682zM11.83 2c-.55 0-.998.448-.998.998v1.682c0 .55.448.998.998.998h1.682c.55 0 .998-.448.998-.998V2.998c0-.55-.448-.998-.998-.998h-1.682zm0 4.691c-.55 0-.998.448-.998.998v1.682c0 .55.448.998.998.998h1.682c.55 0 .998-.448.998-.998v-1.682c0-.55-.448-.998-.998-.998h-1.682zm0 4.34c-.55 0-.998.448-.998.998v1.682c0 .55.448.998.998.998h1.682c.55 0 .998-.448.998-.998v-1.682c0-.55-.448-.998-.998-.998h-1.682z" fill-rule="evenodd"/></svg>'
    };
  }
}